import '../css/ProjectItem.css';

function ProjectContent({ name, type, status, hideStatus, featured }) {
    return (
        <>
            <strong>{name}{featured && <em className="project-featured">Interactive</em>}</strong>
            <span className="project-type">{type}</span>
            <span className="project-status" aria-hidden={hideStatus}>{status}</span>
        </>
    );
}

function ProjectItem({ name, type, href, featured }) {
    if (!href) {
        return (
            <div className="line-item project-item project-entry">
                <ProjectContent
                    name={name}
                    type={type}
                    status="Private"
                    hideStatus={false}
                />
            </div>
        );
    }

    const isExternal = href.startsWith('http');
    return (
        <a
            className="line-item project-item project-link"
            href={href}
            target={isExternal ? '_blank' : undefined}
            rel={isExternal ? 'noreferrer' : undefined}
        >
            <ProjectContent
                name={name}
                type={type}
                status={isExternal ? '↗' : '→'}
                hideStatus
                featured={featured}
            />
        </a>
    );
}

export default ProjectItem;
